module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_lv_latvian-884e7f97a321e3dda41076bbaef04f81.svg";